module.exports = __webpack_public_path__ + "img/ajax-amsterdam.e63e2fd1.png";